import { InvoiceStatus } from '../../../../../enums/invoiceStatus'
import { InvoicesTableAccessor } from '../../../enums/invoicesTableAccessor'

interface GetFilteredInvoicesTableColumnsOptions {
  columns: InvoicesTableAccessor[]
  isCegidOrganization: boolean
  isFrenchComplianceMode?: boolean
  isPdpIntegrationActive?: boolean
  status?: InvoiceStatus
}

export const getFilteredInvoicesTableColumns = ({
  columns,
  isCegidOrganization,
  isFrenchComplianceMode,
  isPdpIntegrationActive,
  status,
}: GetFilteredInvoicesTableColumnsOptions): InvoicesTableAccessor[] => {
  // E-invoice sending is only available in the French compliance mode with an active PDP integration, and draft invoices are never sent.
  const shouldShowEInvoiceStatusColumn =
    !!isFrenchComplianceMode && !!isPdpIntegrationActive && status !== InvoiceStatus.Draft

  // A draft has no payment, so Paid date is not offered under the Drafts filter.
  const shouldShowPaidDateColumn = status !== InvoiceStatus.Draft

  const columnVisibility: Partial<Record<InvoicesTableAccessor, boolean>> = {
    [InvoicesTableAccessor.IntegrationStatus]: isCegidOrganization,
    [InvoicesTableAccessor.EInvoiceStatus]: shouldShowEInvoiceStatusColumn,
    [InvoicesTableAccessor.PaidDate]: shouldShowPaidDateColumn,
  }

  return columns.filter((column) => columnVisibility[column] ?? true)
}
